import {sm2} from 'sm-crypto'

let publicKey = '0424ef8c82e8a09b1954482ccb2cbe45b9eaa6110d091dfc30fa7487d6ffa181a5f9986870444fdaca2b9e7a8514c5c12194d2e465005a157cfcb3ae23d7267a89'

// .eslintrc.json
/**
 * sm2 加密方法
 * @param data
 * @returns {*}
 */
export function encrypt (data) {
    try {
        return sm2.doEncrypt(data, publicKey, 0)
    } catch (e) {
        return ''
    }
}



// WEBPACK FOOTER //
// ./src/utils/sm2.js